<div style="display: flex;gap: 1rem;">
    <table style="background-color: #B3E5FC;padding: 1rem;width: 600px;">
        <thead>
            <tr>
                <th></th>
                <th> Ordrebeholdning </th>
                <th> Budget </th>
                <th> I mdr </th>
            </tr>
        </thead>
        <tbody>
            @for (item of departmentsSummary; track $index) {
            <tr>
                <td>{{item.departmentName}}</td>
                <td>{{item.orderBacklog | number: '1.0-0'}}</td>
                <td>{{item.budget | number: '1.0-0'}}</td>
                <td>{{item.orderBacklogMonths}}</td>
            </tr>
            }
        </tbody>
    </table>
    <table style="padding: 1rem;width: 500px;">
        <thead>
            <tr>
                <th> Estimeret overskud efter løn og fællesomk. </th>
            </tr>
        </thead>
        <tbody>
            @for (item of estimateProfitAfterExpenses; track $index) {
            <tr>
                <td>{{item.estimateProfitAfterExpenses | number:
                    '1.0-0'}}</td>
            </tr>
            }
        </tbody>
    </table>
</div>
